import React, { useState, useEffect } from 'react'

// Components
import OneChoice from './OneChoice'
import MultipleChoices from './MultipleChoices'
import HighestPrice from './HighestPrice'
import UnlimitedOptions from './UnlimitedOptions'

// Redux
import { connect } from 'react-redux'

const Options = ({ item, addOptions, menuData }) => {

    const [optionListData, setOptionListData] = useState([])
    const { menu } = menuData

    useEffect(() => {

        item.Option_List.map(optionUID =>
            setOptionListData(optionListData => [...optionListData, menu.Options.find(option => option.UID === optionUID)])
        )

    }, [item, menu])

    function addChoice(index, choice) {
        if (choice)
            addOptions(index, choice)
    }

    function renderOptions(option, index) {

        if (option.Type === "Unlimited") {
            return <UnlimitedOptions index={index} options={option} addChoice={addChoice} />
        }

        if (option.Highest_Price === true) {
            return <HighestPrice index={index} options={option} addChoice={addChoice} />
        }

        if (option.Choice_Qty === 0 && option.Type === "Fixed") {
            return <MultipleChoices index={index} options={option} addChoice={addChoice} />
        }

        if (option.Choice_Qty <= 1 && option.Type === "Fixed") {
            return <OneChoice index={index} options={option} addChoice={addChoice} />
        } else {
            return <MultipleChoices index={index} options={option} addChoice={addChoice} />
        }

    }

    if (optionListData.length === 0) {
        return (<>Loading....</>)
    }

    return (
        <>
            {optionListData.map((option, index) =>
                <div key={index}>
                    {renderOptions(option, index)}
                </div>
            )}
        </>
    )
}

const mapStateToProps = state => {
    return {
        menuData: state.menuData
    }
}

export default connect(mapStateToProps)(Options)